module.exports = __webpack_public_path__ + "img/46_20.86d89e66.png";